import { LineAbstractInfoModel } from "./line-abstract-info.model";

export class UnitsAbstractInfoModel {
    unitId: string;
    unitName: string;
    lineLevelAbstaractInfo: LineAbstractInfoModel[];
    totalLines: number;
    customMessage: string;

    constructor(unitId: string, unitName: string, lineLevelAbstaractInfo: LineAbstractInfoModel[], totalLines: number, customMessage: string) {
        this.unitId = unitId;
        this.unitName = unitName;
        this.lineLevelAbstaractInfo = lineLevelAbstaractInfo;
        this.totalLines = totalLines;
        this.customMessage = customMessage;
    }
}